import { render, staticRenderFns } from "./AccountHolderInfo-Profile.vue?vue&type=template&id=5b82ff3f"
import script from "./AccountHolderInfo-Profile.vue?vue&type=script&lang=js"
export * from "./AccountHolderInfo-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports